import {
  fetchAllUnsubscriptionCategory,
  updateUnsubscriptionCategory,
  resetSelectedUnsubscriptionCategory,
  fetchUnsubscriptionListByCategoryId,
  deleteUnsubscriptionCategory,
  createUnsubscriptionCategory,
  setUnsubscriptionCategory,
} from '../routines/unsubscribeRoutine';

const initialState = {
  unSubscriptionCategoryList: [],
  unSubscriptionCategoryListLoading: false,
  unSubscriptionCategoryListSuccess: false,
  selectedunSubscriptionCategory: null,
  selectedunSubscriptionCategoryLoading: false,
  selectedunSubscriptionCategorySuccess: false,
  unSubscriptionCategoryCreating: false,
  unSubscriptionCategoryCreateSuccess: false,
  unSubscriptionCategoryUpdating: false,
  unSubscriptionCategoryUpdateSuccess: false,
  unSubscriptionCategoryDeleting: false,
  unSubscriptionCategoryConfiguration: {},
};

const unsubscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    // fetch Unsubscription Category
    case fetchAllUnsubscriptionCategory.TRIGGER:
      return {
        ...state,
        unSubscriptionCategorySuccess: false,
        unSubscriptionCategoryListLoading: true,
      };
    case fetchAllUnsubscriptionCategory.SUCCESS:
      return {
        ...state,
        unSubscriptionCategoryListLoading: false,
        unSubscriptionCategoryListSuccess: true,
        unSubscriptionCategoryList: action.payload?.data || [],
      };
    case fetchAllUnsubscriptionCategory.FAILURE:
      return {
        ...state,
        unSubscriptionCategoryListLoading: false,
        unSubscriptionCategoryListSuccess: false,
      };

    // fetch Unsubscriptions By Category id
    case fetchUnsubscriptionListByCategoryId.TRIGGER:
      return {
        ...state,
        selectedunSubscriptionCategoryLoading: true,
        selectedUnsubscriptiionCategorySuccess: false,
        selectedunSubscriptionCategory: null,
      };
    case fetchUnsubscriptionListByCategoryId.SUCCESS:
      return {
        ...state,
        selectedunSubscriptionCategoryLoading: false,
        selectedunSubscriptionCategorySuccess: true,
        selectedunSubscriptionCategory: action.payload || [],
      };
    case fetchUnsubscriptionListByCategoryId.FAILURE:
      return {
        ...state,
        selectedunSubscriptionCategoryLoading: false,
        selectedunSubscriptionCategorySuccess: false,
      };

    // create unsubscription category
    case createUnsubscriptionCategory.TRIGGER:
      return {
        ...state,
        unSubscriptionCategoryCreateSuccess: false,
        unSubscriptionCategoryCreating: true,
      };
    case createUnsubscriptionCategory.SUCCESS:
      return {
        ...state,
        unSubscriptionCategoryCreateSuccess: true,
        unSubscriptionCategoryCreating: false,
      };
    case createUnsubscriptionCategory.FAILURE:
      return {
        ...state,
        unSubscriptionCategoryCreateSuccess: false,
        unSubscriptionCategoryCreating: false,
      };

    // update unsubscription category
    case updateUnsubscriptionCategory.TRIGGER:
      return {
        ...state,
        unSubscriptionCategoryUpdateSuccess: false,
        unSubscriptionCategoryUpdating: true,
      };
    case updateUnsubscriptionCategory.SUCCESS:
      return {
        ...state,
        unSubscriptionCategoryUpdateSuccess: true,
        unSubscriptionCategoryUpdating: false,
      };
    case updateUnsubscriptionCategory.FAILURE:
      return {
        ...state,
        unSubscriptionCategoryUpdateSuccess: false,
        unSubscriptionCategoryUpdating: false,
      };

    // delete unsubscription category
    case deleteUnsubscriptionCategory.TRIGGER:
      return {
        ...state,
        unSubscriptionCategoryDeleting: true,
      };
    case deleteUnsubscriptionCategory.SUCCESS:
    case deleteUnsubscriptionCategory.FAILURE:
      return {
        ...state,
        unSubscriptionCategoryDeleting: false,
      };

    // reset selected unsubscription category
    case resetSelectedUnsubscriptionCategory.TRIGGER: {
      return {
        ...state,
        selectedunSubscriptionCategory: null,
        selectedunSubscriptionCategoryLoading: false,
        selectedunSubscriptionCategorySuccess: false,
      };
    }

    case setUnsubscriptionCategory.TRIGGER: {
      const { categoryId, categoryName, categoryDescription } = action.payload;
      return {
        ...state,
        unSubscriptionCategoryConfiguration: {
          categoryId,
          categoryName,
          categoryDescription,
        },
      };
    }

    default:
      return state;
  }
};
export default unsubscriptionReducer;
